import EnterpriseComponentAttributeMetadata from "../../EnterpriseComponentAttributeMetadata";
import EnterpriseComponentMetadata from "../../EnterpriseComponentMetadata";

class OrganizationPositionEnterpriseComponentMetadata extends EnterpriseComponentMetadata {
    constructor() {
        super();

        this.name = "OrganizationPosition";
        this.defaultCacheSize = 1000;

        this.attributes["USID"] = new EnterpriseComponentAttributeMetadata(
            "USID", // name
            false, // NoCopy
            true, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            "Position", // Picklist
            null, // Scale
            null, // Precision
            36,   // length
            null, // minLength
            null, // pattern
            "UUID", // Type
            null,  // default value
            false,  // computed
        );
        this.attributes["Realm"] = new EnterpriseComponentAttributeMetadata(
            "Realm", // name
            false, // NoCopy
            true, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            36,   // length
            null, // minLength
            null, // pattern
            "UUID", // Type
            null,  // default value
            false,  // computed
        );
        this.attributes["ParentUSID"] = new EnterpriseComponentAttributeMetadata(
            "ParentUSID", // name
            false, // NoCopy
            false, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            "Position", // Picklist
            null, // Scale
            null, // Precision
            36,   // length
            null, // minLength
            null, // pattern
            "UUID", // Type
            null,  // default value
            false,  // computed
        );
        this.attributes["ParentPositionName"] = new EnterpriseComponentAttributeMetadata(
            "ParentPositionName", // name
            false, // NoCopy
            false, // NoUpdate
            false, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            100,   // length
            null, // minLength
            null, // pattern
            "String", // Type
            null,  // default value
            false,  // computed
        );
        this.attributes["OrganizationUSID"] = new EnterpriseComponentAttributeMetadata(
            "OrganizationUSID", // name
            false, // NoCopy
            false, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            "Organization", // Picklist
            null, // Scale
            null, // Precision
            36,   // length
            null, // minLength
            null, // pattern
            "UUID", // Type
            null,  // default value
            false,  // computed
        );
        this.attributes["OrganizationName"] = new EnterpriseComponentAttributeMetadata(
            "OrganizationName", // name
            false, // NoCopy
            false, // NoUpdate
            false, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            100,   // length
            null, // minLength
            null, // pattern
            "String", // Type
            null,  // default value
            false,  // computed
        );
        this.attributes["Name"] = new EnterpriseComponentAttributeMetadata(
            "Name", // name
            false, // NoCopy
            false, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            100,   // length
            null, // minLength
            null, // pattern
            "String", // Type
            null,  // default value
            false,  // computed
        );
        this.attributes["ParentUSID"] = new EnterpriseComponentAttributeMetadata(
            "ParentUSID", // name
            false, // NoCopy
            false, // NoUpdate
            false, // Required
            false, // RequiredForQuery
            "Position", // Picklist
            null, // Scale
            null, // Precision
            36,   // length
            null, // minLength
            null, // pattern
            "UUID", // Type
            null,  // default value
            false,  // computed
        );
        this.attributes["ParentPositionName"] = new EnterpriseComponentAttributeMetadata(
            "ParentPositionName", // name
            false, // NoCopy
            false, // NoUpdate
            false, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            100,   // length
            null, // minLength
            null, // pattern
            "String", // Type
            null,  // default value
            false,  // computed
        );
        this.attributes["PrimaryAccountUserUSID"] = new EnterpriseComponentAttributeMetadata(
            "PrimaryAccountUserUSID", // name
            false, // NoCopy
            false, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            "AccountUser", // Picklist
            null, // Scale
            null, // Precision
            36,   // length
            null, // minLength
            null, // pattern
            "USID", // Type
            null,  // default value
            false,  // computed
        );
        this.attributes["PrimaryAccountUserName"] = new EnterpriseComponentAttributeMetadata(
            "PrimaryAccountUserName", // name
            false, // NoCopy
            false, // NoUpdate
            false, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            100,   // length
            null, // minLength
            null, // pattern
            "String", // Type
            null,  // default value
            false,  // computed
        );
        this.attributes["CreatedDatetime"] = new EnterpriseComponentAttributeMetadata(
            "CreatedDatetime", // name
            false, // NoCopy
            true, // NoUpdate
            true, // Required
            false, // RequiredForQuery
            null, // Picklist
            null, // Scale
            null, // Precision
            null,   // length
            null, // minLength
            null, // pattern
            "Datetime", // Type
            null,  // default value
            false,  // computed
        );
    }
}

export default OrganizationPositionEnterpriseComponentMetadata;
